(() => {
  const selector = '.product-item__media--ratio';
  const pending = new Set();
  let frame = 0;
  const flush = () => {
    frame = 0;
    const updates = [];
    for (const box of pending) {
      if (!box.isConnected) continue;
      const rect = box.getBoundingClientRect();
      if (!rect.width || !rect.height) continue;
      for (const img of box.querySelectorAll('img[srcset]')) {
        const ratio = Number(img.getAttribute('width')) / Number(img.getAttribute('height')) || 1;
        updates.push([img, Math.ceil(Math.max(rect.width, rect.height * ratio) * Math.max(1, 2 / (window.devicePixelRatio || 1))) + 'px']);
      }
    }
    pending.clear();
    for (const [img, sizes] of updates) if (img.sizes !== sizes) img.sizes = sizes;
  };
  const schedule = box => {
    pending.add(box);
    if (!frame) frame = requestAnimationFrame(flush);
  };
  const resize = new ResizeObserver(entries => { for (const entry of entries) schedule(entry.target); });
  const registered = new WeakSet();
  const scan = root => {
    const boxes = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) boxes.push(root);
    for (const box of boxes) {
      if (registered.has(box)) continue;
      registered.add(box);
      resize.observe(box);
      schedule(box);
    }
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  const additions = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === 1) scan(node);
    }
    for (const record of records) for (const node of record.removedNodes) {
      if (node.nodeType !== 1 || node.isConnected) continue;
      if (node.matches(selector)) { resize.unobserve(node); registered.delete(node); }
      for (const box of node.querySelectorAll(selector)) { resize.unobserve(box); registered.delete(box); }
    }
  });
  additions.observe(document.getElementById('MainContent') || document.body, {childList:true, subtree:true});
})();
